import React from 'react';
import EditPrescriptionModalContainer from '../../containers/modals/EditPrescriptionModalContainer';
import editPrescriptionForm from '../../forms/editPrescriptionPatient/editPrescription';
import editPrescriptionValidations from '../../forms/editPrescriptionPatient/editPrescriptionValidations';

const EditPatientPrescription = (props) => (
    <EditPrescriptionModalContainer
      {...props}
      fromConfig={editPrescriptionForm}
      validationConfig={editPrescriptionValidations} />
);

export default EditPatientPrescription;
